import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import Spinner from 'react-loader-spinner'

import { Link as BaseLink } from 'components/Button'
import { getUser } from 'services/auth'
import { useModal } from 'hooks/useModal'
import ConfirmDialog from 'components/Dialogs/Confirmation'
import {
  fetchRFPList,
  partialUpdateRFPItem,
  deleteRFPById,
} from 'features/requestForProposalList/actions'
import {
  rfpListIsLoadingSelector,
  rfpListSelector,
} from 'features/requestForProposalList/selectors'
import useQueryParams from 'hooks/useQueryParams'
import List from './List'
import StatesMenu from './StatesMenu'

const OutterWrapper = styled.div`
  width: 1000px;
  margin: 0 auto;

  a {
    text-decoration: none;
    margin-bottom: 5px;
    color: ${({ theme }) => theme.colors.text};

    :visited {
      color: ${({ theme }) => theme.colors.text};
    }
  }
`
const Header = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 25px;
`
const Shipper = styled.span`
  font-weight: bold;
  font-size: 20px;
  line-height: 26px;
`
const Link = styled(BaseLink)`
  padding: 10px 20px;
  float: right;
  width: auto;
  height: auto;
`
const InnerWrapper = styled.div`
  display: flex;
`
const SpinnerWrapper = styled.div`
  text-align: center;
  width: 100%;
  margin-top: 100px;
`

export default function RFPList() {
  const user = getUser()
  const dispatch = useDispatch()
  const query = useQueryParams()
  const state = query.get('state') || 'published,closed'
  const isLoading = useSelector(rfpListIsLoadingSelector)
  const data = useSelector(rfpListSelector)
  const { modalState, closeModal, openModal } = useModal()
  const [rfpForDelete, setRfpForDelete] = useState<number>()

  useEffect(() => {
    dispatch(fetchRFPList(state))
  }, [dispatch, state])

  const publishRFP = useCallback(
    (rfp: RequestForProposal) => {
      dispatch(partialUpdateRFPItem(rfp.id, { state: 'published' }))
    },
    [dispatch]
  )
  const confirmRFPDelete = useCallback(
    (rfp: RequestForProposal) => {
      setRfpForDelete(rfp.id)
      openModal()
    },
    [openModal]
  )
  const deleteRFP = useCallback(() => {
    closeModal()
    if (rfpForDelete) dispatch(deleteRFPById(rfpForDelete))
  }, [dispatch, rfpForDelete, closeModal])

  return (
    <OutterWrapper>
      <ConfirmDialog
        title="Permanently remove RFP?"
        description="After this all information will be lost and can not be recovered."
        isOpen={modalState}
        closeModal={closeModal}
        confirm={deleteRFP}
        confirmButtonVariant="danger"
      />
      <Header>
        <Shipper>{user?.shipper_company}</Shipper>
        <Link variant="light" to="/shipper/rfp/add">
          Create new RFP
        </Link>
      </Header>
      <InnerWrapper>
        <StatesMenu selected={state} />
        {isLoading ? (
          <SpinnerWrapper>
            <Spinner type="TailSpin" width={35} height={35} />
          </SpinnerWrapper>
        ) : (
          <List
            rfps={data}
            onClickPublish={publishRFP}
            onClickRemove={confirmRFPDelete}
          />
        )}
      </InnerWrapper>
    </OutterWrapper>
  )
}
